/**
 * Answer Reader Poll
 * @param {string} storyId
 * @param {string} partId
 * @param {string} pollId
 * @param {string} optionId - the option id of the poll answer
 * @returns {poll: object} - Returns the poll with updated interacted data
 */

const clientAPICall = (url, data) => {
    return Promise.resolve(
      $.ajax({
        type: "POST",
        url: url,
        data,
        contentType: "application/json; charset=utf-8",
        xhrFields: {
          withCredentials: true
        },
      })
    );
  };
  
  module.exports = function(storyId, partId, pollId, optionId) {
    return new Promise(async function(resolve, reject) {
      const url = `${wattpad?.apiDomain}/reading/v1/stories/${storyId}/parts/${partId}/polls/${pollId}:answer`;

      const data = {
        optionId,
        type: "singleAnswerPoll"
      };
  
      await clientAPICall(url, JSON.stringify(data))
        .then(poll => {
          return resolve(poll);
        })
        .catch(err => {
          return reject(err);
        });
    });
  };